import { workshopsMUT } from '../../../constants/vuexMutations'
import { workshopsVars } from '../../../constants/vuexVariables'

const mutations = {
  [workshopsMUT.SET_WORKSHOPS] (state, payload) {
    state[workshopsVars.WORKSHOPS] = payload
  }
}
export default mutations



// WEBPACK FOOTER //
// ./src/vuex/modules/workshops/mutations.js